export interface IPartnerMaterialsDocs {
  readonly dealBuilder: string;
  readonly overview: string;
  readonly salesGuide: string;
}

function buildDocs(folder: string): IPartnerMaterialsDocs {
  const base = `/docs/${folder}`;
  return {
    dealBuilder: `${base}/Deal_Builder.html`,
    overview: `${base}/One_Pager.pdf`,
    salesGuide: `${base}/Sales_Guide.pdf`,
  };
}

const PARTNER_MATERIALS_DOCS: ReadonlyMap<string, IPartnerMaterialsDocs> = new Map([
  ['matchbook ai', buildDocs('matchbook_ai')],
  ['brickwork', buildDocs('brickwork')],
  ['okos', buildDocs('okos')],
  ['computer concepts usa', buildDocs('computer_concepts_usa')],
  ['watchkeep', buildDocs('watchkeep')],
]);

export function getPartnerMaterialsDocs(
  partnerName: string | null | undefined,
): IPartnerMaterialsDocs | null {
  const key = partnerName?.trim().toLowerCase();
  return (key && PARTNER_MATERIALS_DOCS.get(key)) || null;
}
